import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionAdditionalFeatureService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllTransactionAdditionalFeatures(page, size, typeNumber) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionAdditionalFeature,
      queryString: `page=${page}&size=${size}&typeNumber=${typeNumber}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdTransactionAdditionalFeatures(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionAdditionalFeature
    }, id);
    return await firstValueFrom(observable);
  }

  async createTransactionAdditionalFeature(name, kindId) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.TransactionAdditionalFeature
    }, {
      name: name,
      kindId: kindId
    });
    return await firstValueFrom(observable);
  }

  async updateTransactionAdditionalFeature(id,name, kindId) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.TransactionAdditionalFeature
    }, {
      id:id,
      name: name,
      kindId: kindId
    });
    return await firstValueFrom(observable);
  }
}
